import { useRef, useState } from 'react'

export const useDrag = () => {
    const containerRef = useRef<HTMLDivElement | null>(null)
    const [isDragging, setIsDragging] = useState(false)
    const [startCoords, setStartCoords] = useState({ x: 0, scrollLeft: 0 })

    const handleDragStart = (e: React.MouseEvent) => {
        // Prevent default behavior (like text selection)
        e.preventDefault()

        const { scrollLeft } = containerRef.current!
        setIsDragging(true)
        setStartCoords({ x: e.pageX, scrollLeft })
        containerRef.current!.style.userSelect = 'none' // Disable text selection during drag
    }

    const handleDragMove = (e: React.MouseEvent) => {
        if (!isDragging) return

        const walkX = e.pageX - startCoords.x
        if (containerRef.current) {
            // Scroll horizontally only (both directions)
            containerRef.current.scrollLeft = startCoords.scrollLeft - walkX
        }
    }

    const handleDragEnd = () => {
        setIsDragging(false)
        if (containerRef.current) {
            containerRef.current.style.userSelect = 'auto' // Re-enable text selection
        }
    }

    return { containerRef, handleDragStart, handleDragMove, handleDragEnd }
}
